import React from "react";

function EventCardSkeleton({ numberOfCards = 1 }) {
  return (
    <div className="grid  grid-cols-1 gap-4 py-5">
      {new Array(numberOfCards).fill(0).map((_, index) => (
        <div key={index}>
          <div className="flex border border-lightGray dark:border-matteGray p-4 rounded-xl space-x-4">
            <div className="animate-pulse bg-frescoWhite dark:bg-darkGray rounded-lg h-98px w-36"></div>
            <div className="w-full flex flex-col space-y-4">
              <div className="flex justify-between">
                <p className="font-medium font-ubuntu text-sm text-darkGray">
                  <p className="rounded-xl w-48 animate-pulse bg-frescoWhite dark:bg-darkGray h-4"></p>
                  <p className="rounded-xl w-20 animate-pulse bg-frescoWhite dark:bg-darkGray h-4 mt-2"></p>
                </p>
                <p className="w-6 h-6 animate-pulse bg-frescoWhite dark:bg-darkGray rounded-full"></p>
              </div>
              <div className="flex flex-col space-y-2">
                <div className="flex justify-between">
                  <div className="flex items-center -ml-1 cursor-pointer">
                    <div className="-space-x-3 flex overflow-hidden">
                      <div className="inline-flex relative overflow-hidden  rounded-full w-10 animate-pulse bg-frescoWhite dark:bg-darkGray h-10 "></div>
                      <div className="inline-flex relative overflow-hidden  rounded-full w-10 animate-pulse bg-frescoWhite dark:bg-darkGray h-10 "></div>
                      <div className="inline-flex relative overflow-hidden  rounded-full w-10 animate-pulse bg-frescoWhite dark:bg-darkGray h-10 "></div>
                    </div>
                    <p className="ml-2 rounded-xl  animate-pulse bg-frescoWhite dark:bg-darkGray h-5 w-16"></p>
                  </div>
                  <div className=" rounded-3xl  animate-pulse bg-frescoWhite dark:bg-darkGray h-9 w-20"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default EventCardSkeleton;
